import { Ajax } from "../utils/base";
import IP from "../config/config"
import QS from "qs"
// const DC = process.env.VUE_APP_DC;
// const NEWS = process.env.VUE_APP_NEWS;
// 模型聚合页入口列表
export function getTransferWx (params) {
    const url = IP.mApis() + `/passport/pay/transfer/wx/${params.trade_no}`;
    return Ajax(url, null, "GET")
}

export function getLiveRoomPriceConfig () {
    const url = IP.mApis() + `/comment/live/article/im-set/conf`;
    return Ajax(url, null, "GET")
}
// 发布修改套餐
export function publishPackage (params) {
    const url = IP.mApis() + `/comment/live/article/im-set/create`;
    return Ajax(url, QS.stringify(params), "POST")
}
// 套餐基本信息
export function getPackageInfo (params) {
    const url = IP.mApis() + `/comment/live/article/im-set/one`;
    return Ajax(url, params, "GET")
}
// 锦囊跳转页面
export function getLiveExpertInfo (params) {
    const url = IP.mApis() + `/comment/live/article/im/info`;
    return Ajax(url, params, "GET")
}
